import ContactSensor from './ContactSensor';

export default class Door extends ContactSensor {}
